import { useState } from "react";
import NewUserOptions from "./NewUserOptions";
import SignupBase from "./SignupBase";

const NewUserSignup = (props) => {
  const [method, setMethod] = useState("");

  if (!method) {
    return (
      <NewUserOptions
        onEmail={() => setMethod("email")}
        onUsername={() => setMethod("username")}
        onPhone={() => setMethod("phone")}
        onCancel={props.onCancel}
      />
    );
  }

  return (
    <SignupBase
      method={method}
      onCancel={() => setMethod("")}
      onCompletion={props.onLoggedIn}
    />
  );
};

export default NewUserSignup;

/*
const NewUserSignUp = (props) => {
  const [selectedMethod, setSelectedMethod] = useState("");

  const cancelHandler = () => {
    setSelectedMethod("");
    props.onCancel?.();
  };

  const completionHandler = (data) => {
    props.onCompletion?.(data);
  };

  if (!selectedMethod) {
    return (
      <NewUserOptions
        onEmail={() => setSelectedMethod("email")}
        onUsername={() => setSelectedMethod("username")}
        onPhone={() => setSelectedMethod("phone")}
        onCancel={cancelHandler}
      />
    );
  }

  return (
    <SignupBase
      method={selectedMethod}
      onCancel={() => setSelectedMethod("")}
      onCompletion={completionHandler}
    />
  );
};

export default NewUserSignUp;
*/

/*
import { useState, useEffect } from "react";
import NewUserOptions from "./NewUserOptions";
import SignupWithEmail from "./SignupWithEmail";
import SignupWithUsername from "./SignupWithUsername";
import SignupWithPhone from "./SignupWithPhone";

function NewUserSignUp(props) {
  const [options, setOptions] = useState(true);
  const [email, setEmail] = useState(false);
  const [username, setUsername] = useState(false);
  const [phone, setPhone] = useState(false);

  const emailHandler = () => {
    setEmail(true);
    setOptions(false);
  };

  const usernameHandler = () => {
    setUsername(true);
    setOptions(false);
  };

  const phoneHandler = () => {
    setPhone(true);
    setOptions(false);
  };

  const handleLoggedIn = (userData) => props.onLoggedIn(userData);

  const cancelHandler = () => {
    setEmail(false);
    setPhone(false);
    setUsername(false);
    setOptions(true);
  };

  return (
    <>
      {options && (
        <NewUserOptions
          onEmail={emailHandler}
          onPhone={phoneHandler}
          onUsername={usernameHandler}
          onCancel={props.onCancel}
        />
      )}
      {email && (
        <SignupWithEmail
          onCompletion={handleLoggedIn}
          onCancel={cancelHandler}
        />
      )}
      {username && (
        <SignupWithUsername
          onCompletion={handleLoggedIn}
          onCancel={cancelHandler}
        />
      )}
      {phone && (
        <SignupWithPhone
          onCompletion={handleLoggedIn}
          onCancel={cancelHandler}
        />
      )}
    </>
  );
}

export default NewUserSignUp;
*/
